// extracted by mini-css-extract-plugin
module.exports = {"card_icon":"non-desktop_card_icon__yOS_i","card_wrap":"non-desktop_card_wrap__xF1cv","image":"non-desktop_image__JSt6o","details":"non-desktop_details__qdDM6"};